import { Children, cloneElement, isValidElement } from 'react';
import { cn } from '@/libs/utils';

/** Two-column field grid; an odd last field takes the whole row. */
export function FieldGrid({ children }) {
  const list = Children.toArray(children).filter(isValidElement);
  return (
    <div className="grid grid-cols-2 gap-x-4">
      {list.map((el, i) =>
        i === list.length - 1 && list.length % 2 === 1
          ? cloneElement(el, {
              className: cn(el.props.className, 'col-span-2'),
            })
          : el
      )}
    </div>
  );
}

/** A titled white block of fields on a profile tile. */
export function Block({ title, children }) {
  return (
    <section>
      <h3 className="mb-2 text-[11px] font-extrabold uppercase tracking-[0.08em] text-zinc-400">
        {title}
      </h3>
      <div className="setting-card-block rounded-xl border border-zinc-200 bg-white px-3 pt-2.5">
        {children}
      </div>
    </section>
  );
}
